import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type IProps = {
  children: ReactNode;
  level?: 'link' | 'label' | 'list';
  color?:
    | 'purple'
    | 'gray'
    | 'blue'
    | 'yellow'
    | 'pink'
    | 'teal'
    | 'black'
    | 'white'
    | 'success'
    | 'error';
  className?: string;
  style?: React.CSSProperties;
};

const LEVEL = {
  link: 'text-[0.8125rem] leading-normal font-black tracking-[0.07em] uppercase no-underline',
  label: 'text-[0.875rem] leading-normal font-black tracking-widest uppercase',
  list: 'text-base leading-normal tracking-[0.02em] no-underline',
};

const NavigationType = ({
  children,
  level = 'link',
  color = 'black',
  className,
  ...props
}: IProps): ReactElement => {
  const textClasses = twMerge(LEVEL[level], `text-type-${color}`, className);

  let navigationEl;

  switch (level) {
    case 'list':
    case 'link': {
      navigationEl = (
        <a className={textClasses} {...props}>
          {children}
        </a>
      );
      break;
    }
    default:
      navigationEl = (
        <p className={textClasses} {...props}>
          {children}
        </p>
      );
  }

  return navigationEl;
};

export default NavigationType;
